export default "__VITE_ASSET__CG4NL9cl__"